<template>
  <div class="container-fluid mt-2" style="font-family:'Wendy's'">
    <div class="text-center">
      <span v-if="userData.logo != 0"><img :src="getFiles(userData.logo)" height="40" /></span>
      <span v-else><img src="@/assets/images/logo.png" height="40" /></span><br>
      <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
      <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
      <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br><br>
      <span style="color: black;font-size:13px" class="text-decoration-underline"><b>MEMBER SAVINGS</b></span><br>
    </div>
    <center>
      <table class="flex-column">
        <tr>
          <td class="text-end"> Full Name: </td>
          <td class="text-start"> <b class=" h7">{{ member.name }} </b></td>
        </tr>
        <tr>
          <td class="text-end"> Member ID: </td>
          <td class="text-start">
            <b v-if="member.sacco_member_id" class=" h7">{{ member.sacco_member_id }} </b>
            <b v-else class=" h7">{{ member.member_id }} </b>
          </td>
        </tr>
        <tr>
          <td class="text-end"> Gender: </td>
          <td class="text-start"> <b class=" h7">{{ member.gender }} </b></td>
        </tr>
        <tr>
          <td class="text-end"> Telephone: </td>
          <td class="text-start"> <b class=" h7">{{ member.telephone }} </b></td>
        </tr>
        <tr>
          <td class="text-end"> Address: </td>
          <td class="text-start"> <b class=" h7">{{ member.address }} </b></td>
        </tr>
      </table>
    </center>
    <div class="text-center">
      <span style="color: black;font-size:14px"><b> AMOUNT SAVED : {{ commas(amount_paid) }} {{ userData.currency
      }}</b></span><br>
      <span style="color:black;font-size:13px">{{ mode_of_payment }} : {{ reference }}</span><br>
      <span style="color: black;font-size:14px"><b> DATE : {{ (date_of_payment) }}</b></span><br>
      <br>
      <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br> {{ new Date().toLocaleDateString('en-US', options) }}
      </p>
      <center><qr-code text="https://telekkasoftware.com" :size="50" error-level="L"></qr-code></center>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import defaultImage from '@/assets/images/tandika-logo.png';


export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      options: { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric" },
      member: [],
      id: '',
      amount_paid: 0,
      date_of_payment: "",
      mode_of_payment: "",
      reference: ''
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    getFiles(name) {
      if (!name) {
        return defaultImage;
      }

      const url = axios.defaults.baseURL;
      return `${url.slice(0, -3)}logos/${name}`;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async fetchInfo() {
      this.id = this.$route.query.id;
      let url = `/findsaving/${this.id}`;
      await axios.get(url).then((response) => {
        this.member = response.data.savings[0].member;
        this.amount_paid = response.data.savings[0].amount;
        this.date_of_payment = response.data.savings[0].date_of_payment;
        this.mode_of_payment = response.data.savings[0].mode_of_payment.name;
        this.reference = response.data.savings[0].reference;
        setTimeout(() => {
          window.print();
          window.onafterprint = this.$router.go(-1);
        }, 1000);
      });
    },
  },
};
</script>